import React, {useState, useEffect } from "react";
import avatar from "./img/img_avatar.png";
import "./infobar.css";

const InfoBar = ({ name, room, userNameOnline, messages,passref }) => {
  const [ifImageFound, setIfImageFound] = useState(false);
  let getUserNameIndex = userNameOnline.findIndex(
    (user) => user == name.toLowerCase()
  ); //getting the name of the name index of the main user
  var getUserName = userNameOnline[getUserNameIndex]; //getting the name of the main user
  delete userNameOnline[getUserNameIndex]; //deleting the main user name from the array.

  const getAdminText = messages.filter(
    (message, i) => message.user === "admin"
  ); //get all the admin messages from all the messages sent
  const getAdminLastMessage = getAdminText.map((message, i) => message.text); //getting the text that was sent by the admin
  const getAdminLastTextMessage = getAdminLastMessage
    .splice(-1, 1)
    .toString(); //getting the new text that was sent by the adming

  fetch(`https://mosboychatapp.herokuapp.com/${name}${room}`).then(response => {
  if(response) {
    if (/not found/.test(response.json())){setIfImageFound(false)}
    else {setIfImageFound(true)}
  }
})
  return(
    <div className="infobar" ref={passref}>
      <div className="OuterContainer">
        <div className="InnerContainer">
        {ifImageFound ? (<img src={`https://mosboychatapp.herokuapp.com/${name}${room}`} alt=" "/>) : (<img src={avatar} alt=" "/>)
        }
          <h3 className="room_name">{room}</h3>
          <select
            title="Active users"  
            style={{
              fontFamily: "monospace",
              fontVariant: "small-caps",
              textAlign: "center",
            }}
          >
            <option
              style={{ fontFamily: "monospace", fontVariant: "small-caps" }}
            >
              {getUserName}
            </option>
            {userNameOnline.map((names, i) => (
              <option className="center" disabled key={i}>
                {names}
              </option>
            ))}
          </select>
          <a href="/">
            <span title="close chat" onClick={()=> localStorage.removeItem(`${name}${room}`)}>&#9876;</span>
          </a>
        </div>
      </div>
       <div className="adminText">{getAdminLastTextMessage}</div>
    </div>
  );
}; 
export default InfoBar;
